<template>
  <div>

    <head>

      <meta charset="utf-8" />
      <title>CBHI | Community-Based Health Insurance</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Keep your finances and membership up to date" name="description" />
      <meta content="Kelvin Njuguna Ndungu" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />

      <!-- Bootstrap select styling -->
      <link rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">

      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />


    </head>

    <body data-sidebar="dark">



    <!-- Begin page -->
    <div id="layout-wrapper">


      <NavigationBar/>



      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">

        <div class="page-content">
          <div class="container-fluid">

            <!-- start page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Dashboard</h4>

                  <div class="page-title-right d-flex align-items-center">
                    <!-- Current Date Display -->
                    <div class="text-muted small me-3">
                      <i class="bx bx-calendar-check me-1"></i>
                      {{ currentDateDisplay }}
                    </div>

                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>

            <!-- quick stats -->
            <div class="row">
              <div class="col-xl-12 px-sm-30px">
                <div class="card dash-snapshort bg-primary-alt card-hover">
                  <div class="card-header p-4 bg-transparent">
                    <h5 class="text-white mb-0"><i class="bx bx-stats me-2"></i> CBHI Membership
                      Snapshot
                      <small class="ms-2 opacity-75">{{ activePeriodDisplay }}</small>
                    </h5>
                  </div>
                  <div class="card-body bg-transparent p-4">
                    <div class="row text-capitalize">

                      <div class="col-12 col-sm-12 col-md-3">
                        <div class="d-flex align-center bg-white p-3 bg-opacity-10">
                          <div>
                            <div class="avatar-xs me-3">
                                                        <span
                                                            class="avatar-title rounded-circle bg-white bg-opacity-10 bg-soft text-warning font-size-18">
                                                            <i class="bx bx-group"></i>
                                                        </span>
                            </div>
                          </div>
                          <div>
                            <div>
                              <h3 class="fw-bold text-white fs-2 text">{{ formatNumber(dashboardStats.totalMembers) }}</h3>
                            </div>

                            <p class="text-light mb-0 opacity-75">Total Registered CBHI Members
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-sm-12 col-md-3">
                        <div class="d-flex align-center bg-white p-3 bg-opacity-10">
                          <div>
                            <div class="avatar-xs me-3">
                                                        <span
                                                            class="avatar-title rounded-circle bg-white bg-opacity-10 bg-soft text-warning font-size-18">
                                                            <i class="bx bx-calendar"></i>
                                                        </span>
                            </div>
                          </div>
                          <div>
                            <h3 class="fw-bold text-white fs-3 text">{{ activePeriodDisplay }}</h3>
                            <p class="text-warning mb-0">Active Period</p>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-sm-12 col-md-3">
                        <div class="d-flex align-center bg-white p-3 bg-opacity-10">
                          <div>
                            <div class="avatar-xs me-3">
                                                        <span
                                                            class="avatar-title rounded-circle bg-white bg-opacity-10 bg-soft text-warning font-size-18">
                                                            <i class="bx bx-timer"></i>
                                                        </span>
                            </div>
                          </div>
                          <div>
                            <h3 class="fw-bold text-white fs-2 text">{{ dashboardStats.daysUntilExpiry }}</h3>
                            <p class="text-light mb-0 opacity-75">Days Until Expiry</p>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-sm-12 col-md-3">
                        <div class="d-flex align-center bg-white p-3 bg-opacity-10">
                          <div>
                            <div class="avatar-xs me-3">
                                                        <span
                                                            class="avatar-title rounded-circle bg-white bg-opacity-10 bg-soft text-warning font-size-18">
                                                            <i class="bx bx-user-plus"></i>
                                                        </span>
                            </div>
                          </div>
                          <div>
                            <h3 class="fw-bold text-white fs-2 text">{{ formatNumber(dashboardStats.newMembersMonth) }}</h3>
                            <p class="text-light mb-0 opacity-75">New Members {{ currentMonthDisplay }}</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 px-sm-30px">
                <div class="card member-wedges-card">
                  <div class="card-header bg-white">
                    <h5 class="mb-0 me-2 text-black">Premium Collection Summary in ETB</h5>
                    <small class="text-muted">{{ currentYear }}</small>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-6 text-center mb-4">
                        <div
                            class="flex-fill p-3 rounded-1 border border-dashed border-gray-5 border-2 border-dark">
                          <div class="avatar-xs mx-auto mb-3">
                                                    <span class="avatar-title rounded-circle bg-success font-size-16">
                                                        <i class="mdi mdi-cash-multiple text-white"></i>
                                                    </span>
                          </div>
                          <h6 class="fs-15 fw-semibold text-success text fs-4 mb-1">{{ formatCurrency(premiumSummary.totalCollected2025) }}
                          </h6>
                          <p class="fs-12 text-muted mb-0">Total Collected ({{ currentYear }})</p>
                        </div>
                      </div>

                      <div class="col-6 text-center mb-4">
                        <div
                            class="flex-fill p-3 rounded-1 border border-dashed border-gray-5 border-2 border-dark">
                          <div class="avatar-xs mx-auto mb-3">
                                                    <span class="avatar-title rounded-circle bg-info font-size-16">
                                                        <i class="mdi mdi-calendar-month text-white"></i>
                                                    </span>
                          </div>
                          <h6 class="fs-15 fw-semibold text-info text fs-4 mb-1">{{ formatCurrency(premiumSummary.thisMonth) }}</h6>
                          <p class="fs-12 text-muted mb-0">{{ currentMonthDisplay }}</p>
                        </div>
                      </div>

                      <div class="col-12">
                        <h5 class="mb-3 me-2 text-black">Top 5 Woredas</h5>
                        <div>
                          <div v-for="woreda in premiumSummary.topWoredas" :key="woreda.woreda_name" class="mb-4">
                            <div class="d-flex justify-content-between">
                              <h6>{{ woreda.woreda_name }}</h6>
                              <h6 class="text-right">
                                                            <span class="fw-bold">
                                                                <span class="text-black">ETB {{ formatCurrency(woreda.total_amount) }}</span>
                                                                <span class="ms-2">{{ woreda.percentage }}%</span>
                                                            </span>
                              </h6>
                            </div>
                            <div class="progress progress-l">
                              <div class="progress-bar bg-black" role="progressbar"
                                   :style="`width: ${woreda.percentage}%`" :aria-valuenow="woreda.percentage" aria-valuemin="0"
                                   aria-valuemax="100"></div>
                            </div>
                          </div>
                        </div>


                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 px-sm-30px">
                <div class="card  member-wedges-card">
                  <div class="card-header bg-white">
                    <h5 class="mb-0 me-2 text-black">Hospital Visit Activity</h5>
                  </div>
                  <div class="card-body">


                    <div class="row">
                      <!-- Today's Visits -->
                      <div class="col-6 text-center mb-4">
                        <div
                            class="stat-card flex-fill p-3 rounded-3 border border-dashed border-2 bg-light">
                          <div class="avatar-xs mx-auto mb-3">
                                                    <span class="avatar-title rounded-circle bg-dark">
                                                        <i class="bx bx-pulse text-white fs-5"></i>
                                                    </span>
                          </div>
                          <h6 class="fs-4 fw-bold text-dark mb-1">{{ formatNumber(hospitalActivity.visitsToday) }}</h6>
                          <p class="fs-6 text-muted mb-0">Visits Today</p>
                        </div>
                      </div>

                      <!-- This Month's Visits -->
                      <div class="col-6 text-center mb-4">
                        <div
                            class="stat-card flex-fill p-3 rounded-3 border border-dashed border-2 bg-light">
                          <div class="avatar-xs mx-auto mb-3">
                                                    <span class="avatar-title rounded-circle bg-dark">
                                                        <i class="mdi-chart-bar mdi text-white fs-5"></i>
                                                    </span>
                          </div>
                          <h6 class="fs-4 fw-bold text-dark mb-1">{{ formatNumber(hospitalActivity.visitsThisMonth) }}</h6>
                          <p class="fs-6 text-muted mb-0">Visits {{ currentMonthDisplay }}</p>
                        </div>
                      </div>

                      <div class="col-12">
                        <h5 class="mb-3 me-2 text-black">Payment Method Distribution</h5>
                        <div>
                          <div v-for="method in hospitalActivity.paymentMethods" :key="method.method_name" class="mb-4">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <h6 class="mb-0">{{ method.method_name }}</h6>
                              <div class="text-right">
                                <div class="fw-bold">
                                  <span class="text-black d-block">ETB {{ method.total_amount }}</span>
                                  <span class="text-muted small">{{ method.percentage }}%</span>
                                </div>
                              </div>
                            </div>
                            <div class="progress progress-l">
                              <div class="progress-bar bg-primary" role="progressbar"
                                   :style="`width: ${method.percentage}%`" :aria-valuenow="method.percentage" aria-valuemin="0"
                                   aria-valuemax="100"></div>
                            </div>
                          </div>
                        </div>

                      </div>


                    </div>


                  </div>

                </div>
              </div>

              <div class="col-xl-4 col-lg-4 px-sm-30px">
                <div class="card  member-wedges-card">
                  <div class="card-header bg-white">
                    <h5 class="mb-0 me-2 text-black">Woreda Settlements & Reconciliation</h5>
                  </div>
                  <div class="card-body">


                    <div class="row">
                      <!-- Settled Transactions -->
                      <div class="col-6 text-center mb-4">
                        <div
                            class="stat-card flex-fill p-3 rounded-3 border border-dashed border-2 bg-success bg-soft ">
                          <div class="avatar-xs mx-auto mb-3">
                                                    <span class="avatar-title rounded-circle bg-success">
                                                        <i class="bx bx-check-circle text-white fs-5"></i>
                                                    </span>
                          </div>
                          <h6 class="fs-4 fw-bold text-dark mb-1">{{ formatCurrency(settlements.settledTransactions) }}</h6>
                          <p class="fs-6 text-muted mb-0">Settled Transactions</p>
                        </div>
                      </div>

                      <!-- Unsettled Transactions -->
                      <div class="col-6 text-center mb-4">
                        <div
                            class="stat-card flex-fill p-3 rounded-3 border border-dashed border-2 bg-warning bg-soft">
                          <div class="avatar-xs mx-auto mb-3">
                                                    <span class="avatar-title rounded-circle bg-warning">
                                                        <i class="bx bx-time-five text-white fs-5"></i>

                                                    </span>
                          </div>
                          <h6 class="fs-4 fw-bold text-dark mb-1">{{ formatCurrency(settlements.unsettledTransactions) }}</h6>
                          <p class="fs-6 text-muted mb-0">Unsettled Transactions</p>
                        </div>
                      </div>

                      <div class="col-12">
                        <h5 class="mb-3 me-2 text-black">Settlements & Reconciliation</h5>
                        <div class="row settle-stats">
                          <!-- Outstanding to Woredas -->
                          <div class="col-12">
                            <div
                                class="d-flex w-100 justify-content-between align-items-center p-3 bg-info bg-soft mb-3 border-primary border-primary">
                              <p class="fw-bold mb-0 pb-0 d-flex align-items-center">
                                <i class="bx bx-money text fs-3 text-primary me-2"></i>
                                <span class="text-black">Outstanding to Woredas</span>
                              </p>
                              <h5 class="fw-bold text-primary text-right mb-0 pb-0">ETB
                                {{ formatCurrency(settlements.outstandingToWoredas) }}</h5>
                            </div>
                          </div>

                          <!-- Flagged Hospital Transactions -->
                          <div class="col-12">
                            <div
                                class="d-flex w-100 justify-content-between align-items-center p-3 bg-danger bg-soft mb-3 border-primary border-danger">
                              <p class="fw-bold mb-0 pb-0 d-flex align-items-center">
                                <i class="bx bx-error text fs-3 text-danger me-2"></i>
                                <span class="text-black">Flagged Hospital
                                                                Transactions</span>
                              </p>
                              <h5 class="fw-bold text-danger text-right mb-0 pb-0">{{ settlements.flaggedHospitalTransactions }}
                              </h5>
                            </div>
                          </div>

                          <!-- Reconciliation Pending > 5 Days -->
                          <div class="col-12">
                            <div
                                class="d-flex w-100 justify-content-between align-items-center p-3 bg-warning bg-soft mb-3 border-primary border-warning">
                              <p class="fw-bold mb-0 pb-0 d-flex align-items-center">
                                <i class="bx bx-time text fs-3 text-danger me-2"></i>
                                <span class="text-black">Reconciliation Pending > 5
                                                                Days</span>
                              </p>
                              <h5 class="fw-bold text-warning text-right mb-0 pb-0">{{ settlements.reconciliationPending }}</h5>
                            </div>
                          </div>
                        </div>


                      </div>


                    </div>


                  </div>

                </div>
              </div>

              <div class="col-xl-4 col-lg-4 px-sm-30px">
                <div class="card  member-wedges-card">
                  <div class="card-header bg-white">
                    <h5 class="mb-0 me-2 text-black">Claims Summary</h5>
                  </div>
                  <div class="card-body">


                    <div class="row">
                      <!-- Total Claims -->
                      <div class="col-6 text-center mb-4">
                        <div
                            class="stat-card flex-fill p-3 rounded-3 border border-dashed border-2 bg-info bg-soft ">
                          <div class="avatar-xs mx-auto mb-3">
                                                    <span class="avatar-title rounded-circle bg-primary">
                                                        <i class="bx bx-check-circle text-white fs-5"></i>
                                                    </span>
                          </div>
                          <h6 class="fs-4 fw-bold text-primary mb-1">{{ formatNumber(claimsSummary.totalClaims) }}</h6>
                          <p class="fs-6 text-muted mb-0">Total Claims</p>
                        </div>
                      </div>

                      <!-- This Month Claims -->
                      <div class="col-6 text-center mb-4">
                        <div
                            class="stat-card flex-fill p-3 rounded-3 border border-dashed border-2 bg-info bg-soft">
                          <div class="avatar-xs mx-auto mb-3">
                                                    <span class="avatar-title rounded-circle bg-primary">
                                                        <i class="bx bx-time-five text-white fs-5"></i>

                                                    </span>
                          </div>
                          <h6 class="fs-4 fw-bold text-primary mb-1">{{ formatNumber(claimsSummary.thisMonth) }}</h6>
                          <p class="fs-6 text-muted mb-0">{{ currentMonthDisplay }}</p>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="row settle-stats">

                          <!-- Approved Claims -->
                          <div class="col-12">
                            <div
                                class="d-flex w-100 justify-content-between align-items-center p-3 bg-success bg-soft mb-3 border border-success rounded">
                              <p class="mb-0 pb-0 d-flex align-items-center">
                                <i class="bx bx-check-circle fs-3 text-success me-2"></i>
                                <span class="fs-5 text-black">Approved</span>
                              </p>
                              <h5 class="fw-bold text-success text-end mb-0 pb-0">
                                                            <span
                                                                class="badge rounded-pill bg-success text-white fs-5">{{ formatNumber(claimsSummary.approved) }}</span>
                              </h5>
                            </div>
                          </div>

                          <!-- Pending Claims -->
                          <div class="col-12">
                            <div
                                class="d-flex w-100 justify-content-between align-items-center p-3 bg-warning bg-soft mb-3 border border-warning rounded">
                              <p class="mb-0 pb-0 d-flex align-items-center">
                                <i class="bx bx-time-five fs-3 text-warning me-2"></i>
                                <span class="fs-5 text-black">Pending</span>
                              </p>
                              <h5 class="fw-bold text-warning text-end mb-0 pb-0">
                                                            <span
                                                                class="badge rounded-pill bg-warning text-black fs-5">{{ formatNumber(claimsSummary.pending) }}</span>
                              </h5>
                            </div>
                          </div>

                          <!-- Rejected Claims -->
                          <div class="col-12">
                            <div
                                class="d-flex w-100 justify-content-between align-items-center p-3 bg-danger bg-soft mb-3 border border-danger rounded">
                              <p class="mb-0 pb-0 d-flex align-items-center">
                                <i class="bx bx-x-circle fs-3 text-danger me-2"></i>
                                <span class="fs-5 text-black">Rejected</span>
                              </p>
                              <h5 class="fw-bold text-danger text-end mb-0 pb-0">
                                                            <span
                                                                class="badge rounded-pill bg-danger text-white fs-5">{{ formatNumber(claimsSummary.rejected) }}</span>
                              </h5>
                            </div>
                          </div>

                        </div>
                      </div>





                    </div>


                  </div>

                </div>
              </div>
              <div class="col-xl-8 col-lg-4 px-sm-30px">
                <div class="card  member-wedges-card">
                  <div class="card-header bg-white">
                    <h5 class="mb-0 me-2 text-black">Monthly Claims vs Premiums (ETB) - {{ currentYear }}</h5>
                  </div>
                  <div class="card-body">
                    <div id="annual-sales" class="high-chart-cont" dir="ltr"></div>
                  </div>

                </div>
              </div>


            </div>
            <!-- end of quick stats -->

          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->


        <footer class="footer ">
          <div class="container-fluid ">
            <div class="row ">
              <div class="col-sm-6 ">

              </div>
              <div class="col-sm-6 ">
                <div class="text-sm-end d-sm-block ">
                  Ministry of Health
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <!-- end main content-->

    </div>
    <!-- END layout-wrapper -->

    <!-- Right bar overlay-->
    <div class="rightbar-overlay "></div>

    </body>


  </div>

</template>
<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { executeJson, authUrl } from "@/api";

export default {
  name: "dashboard-Page",
  components: { NavigationBar },
  data() {
    return {
      refreshInterval: null,

      // Month names
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],

      dashboardStats: {
        totalMembers: 0,
        activeMembers: 0,
        newMembersMonth: 0,
        daysUntilExpiry: 0,
        activePeriod: 'Jan 2025 - Dec 2025'
      },
      premiumSummary: {
        totalCollected2025: 0,
        thisMonth: 0,
        topWoredas: []
      },
      hospitalActivity: {
        visitsToday: 0,
        visitsThisMonth: 0,
        paymentMethods: []
      },
      settlements: {
        settledTransactions: 0,
        unsettledTransactions: 0,
        outstandingToWoredas: 0,
        flaggedHospitalTransactions: 0,
        reconciliationPending: 0
      },
      claimsSummary: {
        totalClaims: 0,
        thisMonth: 0,
        approved: 0,
        pending: 0,
        rejected: 0
      },
      chartData: {
        months: [],
        premiums: [],
        claims: [],
        visits: []
      }
    };
  },

  computed: {
    // Current date display
    currentDateDisplay() {
      const today = new Date();
      return today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    },

    // Current month display
    currentMonthDisplay() {
      return this.months[new Date().getMonth()];
    },

    // Current year
    currentYear() {
      return new Date().getFullYear();
    },

    // Active period display
    activePeriodDisplay() {
      return this.dashboardStats.activePeriod || 'Jan 2025 - Dec 2025';
    }
  },

  mounted() {
    this.loadDashboard();

    // Auto-refresh every 5 minutes
    this.refreshInterval = setInterval(() => {
      this.loadDashboard();
    }, 300000);
  },

  beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },

  methods: {
    // ==================== DATE FORMATTING ====================

    formatDateDisplay(dateString) {
      if (!dateString) return '-';
      const d = new Date(dateString);
      return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    },

    // ==================== DASHBOARD DATA METHODS ====================

    async loadDashboard() {
      try {
        // Load all dashboard data in parallel
        await Promise.all([
          this.getDashboardStats(),
          this.getPremiumCollectionSummary(),
          this.getHospitalVisitActivity(),
          this.getSettlementsReconciliation(),
          this.getClaimsSummary(),
          this.getMonthlyClaimsVsPremiums()
        ]);

        // Render chart after data is loaded
        this.$nextTick(() => {
          this.monthlyClaimsvsPremiums();
        });

      } catch (error) {
        console.error('Error loading dashboard:', error);
      }
    },

    async getDashboardStats() {
      const data = { "function": "getDashboardStats" };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.dashboardStats = response.data.data.stats;
        }
      } catch (error) {
        console.error('Error fetching dashboard stats:', error);
      }
    },

    async getPremiumCollectionSummary() {
      const data = { "function": "getPremiumCollectionSummary" };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.premiumSummary = response.data.data.summary;
        }
      } catch (error) {
        console.error('Error fetching premium summary:', error);
      }
    },

    async getHospitalVisitActivity() {
      const data = { "function": "getHospitalVisitActivity" };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.hospitalActivity = response.data.data.activity;
        }
      } catch (error) {
        console.error('Error fetching hospital activity:', error);
      }
    },

    async getSettlementsReconciliation() {
      const data = { "function": "getSettlementsReconciliation" };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.settlements = response.data.data.settlements;
        }
      } catch (error) {
        console.error('Error fetching settlements:', error);
      }
    },

    async getClaimsSummary() {
      const data = { "function": "getClaimsSummary" };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.claimsSummary = response.data.data.claims;
        }
      } catch (error) {
        console.error('Error fetching claims summary:', error);
      }
    },

    async getMonthlyClaimsVsPremiums() {
      const data = { "function": "getMonthlyClaimsVsPremiums" };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.chartData = response.data.data.chartData;
        }
      } catch (error) {
        console.error('Error fetching chart data:', error);
      }
    },

    // ==================== CHART METHODS ====================

    getDataScale(values) {
      const maxValue = Math.max(...values.filter(v => v > 0));
      if (maxValue >= 1000000) return { scale: 1000000, suffix: 'M', title: 'Amount (ETB Millions)' };
      if (maxValue >= 1000) return { scale: 1000, suffix: 'K', title: 'Amount (ETB Thousands)' };
      return { scale: 1, suffix: '', title: 'Amount (ETB)' };
    },

    getDynamicFormatter(scale, suffix) {
      return function() {
        if (scale === 1) return 'ETB ' + this.value.toFixed(0);
        return 'ETB ' + (this.value / scale).toFixed(1) + suffix;
      };
    },

    getDynamicTooltipFormatter(scale, suffix) {
      return function() {
        if (scale === 1) {
          return '<span style="color:' + this.color + '">\u25CF</span> ' + this.series.name + ': <b>ETB ' + Highcharts.numberFormat(this.y, 0, '.', ',') + '</b><br/>';
        }
        const scaledValue = this.y / scale;
        return '<span style="color:' + this.color + '">\u25CF</span> ' + this.series.name + ': <b>ETB ' + scaledValue.toFixed(1) + suffix + ' (' + Highcharts.numberFormat(this.y, 0, '.', ',') + ')</b><br/>';
      };
    },

    monthlyClaimsvsPremiums() {
      if (!this.chartData.months.length) return;

      const chartLabels = this.chartData.months;

      const allFinancialValues = [...this.chartData.premiums, ...this.chartData.claims];
      const financialScale = this.getDataScale(allFinancialValues);
      const visitScale = this.getDataScale(this.chartData.visits);

      const financialFormatter = this.getDynamicFormatter(financialScale.scale, financialScale.suffix);
      const visitFormatter = this.getDynamicFormatter(visitScale.scale, visitScale.suffix);
      const financialTooltipFormatter = this.getDynamicTooltipFormatter(financialScale.scale, financialScale.suffix);

      Highcharts.chart('annual-sales', {
        chart: {
          zoomType: 'xy',
          style: { fontFamily: '"Poppins", sans-serif' }
        },
        title: {
          text: `Hospital Performance Dashboard ${this.currentYear}`,
          align: 'center',
          style: { fontSize: '18px', fontWeight: 'bold', color: '#023382' }
        },
        xAxis: [{
          categories: chartLabels,
          crosshair: true,
          lineWidth: 0,
          tickWidth: 0
        }],
        yAxis: [{
          labels: { style: { color: '#023382' }, formatter: financialFormatter },
          title: { text: financialScale.title, style: { color: '#023382' } },
          gridLineColor: '#e6e6e6',
          gridLineWidth: 1,
          min: 0
        }, {
          title: { text: visitScale.title.replace('Amount', 'Hospital Visits'), style: { color: '#b03a48' } },
          labels: { style: { color: '#b03a48' }, formatter: visitFormatter },
          opposite: true,
          gridLineWidth: 0,
          min: 0
        }],
        tooltip: {
          shared: true,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#cccccc',
          borderRadius: 10,
          shadow: true
        },
        plotOptions: {
          column: { pointPadding: 0.1, borderWidth: 0, groupPadding: 0.1, borderRadius: 0 },
          spline: { marker: { enabled: true, radius: 5 }, lineWidth: 3 }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          itemStyle: { fontWeight: 'normal' }
        },
        series: [{
          name: 'Total Premiums Paid',
          type: 'column',
          color: '#023382',
          yAxis: 0,
          data: this.chartData.premiums,
          tooltip: { pointFormatter: financialTooltipFormatter }
        }, {
          name: 'Total Claims Settled',
          type: 'column',
          color: '#7faed4',
          yAxis: 0,
          data: this.chartData.claims,
          tooltip: { pointFormatter: financialTooltipFormatter }
        }, {
          name: 'Hospital Visits',
          type: 'spline',
          color: '#b03a48',
          yAxis: 1,
          data: this.chartData.visits,
          tooltip: {
            pointFormatter: function() {
              return '<span style="color:' + this.color + '">\u25CF</span> ' + this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, '.', ',') + ' visits</b><br/>';
            }
          },
          marker: { fillColor: '#b03a48', lineColor: '#b03a48', lineWidth: 2 }
        }]
      });
    },

    // ==================== FORMATTING METHODS ====================

    formatNumber(number) {
      if (!number) return '0';
      return new Intl.NumberFormat().format(number);
    },

    formatCurrency(amount) {
      if (!amount) return '0';

      if (typeof amount === 'string') {
        if (amount.includes(',')) return amount;
        const numericValue = parseFloat(amount.replace(/,/g, ''));
        if (!isNaN(numericValue)) return new Intl.NumberFormat().format(numericValue);
        return amount;
      }

      return new Intl.NumberFormat().format(amount);
    }
  }
};
</script>

<style>
.high-chart-cont {
  min-height: 400px;
  height: 100%;
  width: 100%;
  display: block;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.stat-card:hover {
  transform: translateY(-2px);
  transition: transform 0.3s ease;
}

.progress-l {
  height: 8px;
}

/* Additional styles for better Payment Method Distribution layout */
.payment-method-item {
  margin-bottom: 1rem;
}

.payment-method-header {
  display: flex;
  justify-content: between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.payment-method-values {
  text-align: right;
}

.payment-method-amount {
  display: block;
  font-weight: bold;
  color: #000;
  font-size: 0.9rem;
}

.payment-method-percentage {
  display: block;
  color: #6c757d;
  font-size: 0.8rem;
  margin-top: 2px;
}
</style>